import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0623a3e6&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=0623a3e6&prod&scoped=true&lang=less&"
import style1 from "./home.vue?vue&type=style&index=1&id=0623a3e6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0623a3e6",
  null
  
)

export default component.exports